// validate_proposal.js
document.addEventListener('turbolinks:load', function() {
    setupFormValidation();

    // Make sure this runs after Turbolinks load as well
    document.addEventListener('turbolinks:load', setupFormValidation);

    function setupFormValidation() {
      const form = document.getElementById('new-proposal-form');
      if (!form) return;

      console.log('Form validation initialized');

      // Mark form as using client-side validation
      form.setAttribute('novalidate', true);

      // Find form fields - use multiple selectors to ensure we find them
      const fields = {
        name: form.querySelector('[name="order[hoa_name]"]') || form.querySelector('[name="order[name]"]'),
        electionType: form.querySelector('[name="order[election_value]"]') || form.querySelector('[name="order[election_type]"]'),
        totalUnits: form.querySelector('[name="order[number_of_units]"]'),
        mailedUnits: form.querySelector('[name="order[estimated_mailed_units]"]'),
        meetingDate: form.querySelector('[name="order[meeting_date]"]'),
        firstName: form.querySelector('[name="order[contacts_attributes][0][first_name]"]') || form.querySelector('input[name*="[first_name]"]'),
        lastName: form.querySelector('[name="order[contacts_attributes][0][last_name]"]') || form.querySelector('input[name*="[last_name]"]'),
        email: form.querySelector('[name="order[contacts_attributes][0][email]"]') || form.querySelector('input[name*="[email]"]') || form.querySelector('input[type="email"]')
      };

      // Get other elements
      const electronicBallots = document.getElementById('electronic-ballots');
      const submitButton = form.querySelector('input[type="submit"]');

      // Initialize electronic ballots field
      if (electronicBallots) {
        electronicBallots.setAttribute('disabled', true);
      }

      // Apply special assessment rule on initial load
      if (fields.electionType) {
        handleSpecialAssessmentSelection(fields, electronicBallots);
      }

      // Listen for election type changes
      if (fields.electionType) {
        fields.electionType.addEventListener('change', function() {
          handleSpecialAssessmentSelection(fields, electronicBallots);
          validateElectronicBallots();
        });
      }

      // Set up event listeners for auto-calculations
      if (fields.totalUnits) {
        fields.totalUnits.addEventListener('blur', function() {
          updateBallotCounts(fields, electronicBallots);
          // Apply special assessment rule when total units changes
          handleSpecialAssessmentSelection(fields, electronicBallots);
          // Also validate the relationship between all fields
          validateElectronicBallots();
        });

        // Also watch for input events to provide immediate feedback
        fields.totalUnits.addEventListener('input', function() {
          // Remove any errors on electronic ballots when total changes
          removeError(electronicBallots);
          removeError(fields.mailedUnits);
        });
      }

      if (electronicBallots) {
        electronicBallots.addEventListener('input', function() {
          // Don't update paper ballots if special assessment
          if (fields.electionType && fields.electionType.value !== 'SPA') {
            updatePaperBallots(fields, electronicBallots);
          }
          // Validate on input to provide immediate feedback
          validateElectronicBallots();
        });

        // Also validate on blur
        electronicBallots.addEventListener('blur', function() {
          validateElectronicBallots();
        });
      }

      if (fields.mailedUnits) {
        fields.mailedUnits.addEventListener('input', function() {
          // Don't update electronic ballots if special assessment
          if (fields.electionType && fields.electionType.value !== 'SPA') {
            updateElectronicBallots(fields, electronicBallots);
          }
          // Validate on input to provide immediate feedback
          validateElectronicBallots();
        });

        // Also validate on blur
        fields.mailedUnits.addEventListener('blur', function() {
          validateElectronicBallots();
        });
      }

      // Live validation for specific fields
      if (fields.email) {
        fields.email.addEventListener('blur', function() {
          validateEmail(fields.email);
        });
      }

      if (fields.meetingDate) {
        fields.meetingDate.addEventListener('blur', function() {
          validateMeetingDate(fields.meetingDate);
        });
      }

      // Clear error indicators when user fixes the field
      Object.values(fields).forEach(function(field) {
        if (field && field !== fields.email) {
          field.addEventListener('input', function() {
            removeError(field);
          });
        }
      });

      // CRITICAL: Handle BOTH form submission and button click

      // Handle the submit button click
      if (submitButton) {
        submitButton.addEventListener('click', function(e) {
          console.log('Submit button clicked, running validation');

          // Run validation directly from the click event
          if (!validateForm(form, fields)) {
            e.preventDefault();
            console.log('Validation failed on button click');
            forceScrollToFirstError();
            return false;
          }

          console.log('Validation passed on button click');
        });
      }

      // Also handle the form submit event as a backup
      form.addEventListener('submit', function(e) {
        console.log('Form submit event triggered');

        // Run validation
        if (!validateForm(form, fields)) {
          e.preventDefault();
          console.log('Validation failed on form submit');
          forceScrollToFirstError();
          return false;
        }

        console.log('Validation passed on form submit');
      });
    }

    // Handle special assessment type selection
    function handleSpecialAssessmentSelection(fields, electronicBallots) {
      if (!fields.electionType || !fields.totalUnits || !fields.mailedUnits || !electronicBallots) return;

      // Check if Special Assessment is selected (SPA is the value for Special Assessment)
      const isSpecialAssessment = fields.electionType.value === 'SPA';

      if (isSpecialAssessment) {
        // Get the total units value
        const total = parseInt(fields.totalUnits.value, 10) || 0;

        // Set paper ballots to match total units
        fields.mailedUnits.value = total;
        highlightAnimateField(fields.mailedUnits);

        // Set electronic ballots to 0
        electronicBallots.value = 0;

        // Disable electronic ballots input
        electronicBallots.setAttribute('disabled', true);

        // Add a note about why electronic is disabled (optional)
        let noteId = 'electronic-ballots-spa-note';
        if (!document.getElementById(noteId)) {
          const noteElement = document.createElement('p');
          noteElement.id = noteId;
          noteElement.className = 'mt-1 text-xs text-amber-600';
          noteElement.textContent = 'Electronic ballots are not permitted for Special Assessments';

          if (electronicBallots.parentNode) {
            electronicBallots.parentNode.appendChild(noteElement);
          }
        }
      } else {
        // Remove any notice about electronic ballots if not special assessment
        const noteElement = document.getElementById('electronic-ballots-spa-note');
        if (noteElement && noteElement.parentNode) {
          noteElement.parentNode.removeChild(noteElement);
        }

        // Enable electronic ballots input if total units has a valid value
        const total = parseInt(fields.totalUnits.value, 10) || 0;
        if (total > 0) {
          electronicBallots.removeAttribute('disabled');
        }
      }
    }

    // Validate the electronic ballots field
    function validateElectronicBallots() {
      const form = document.getElementById('new-proposal-form');
      if (!form) return;

      const fields = {
        totalUnits: form.querySelector('[name="order[number_of_units]"]'),
        mailedUnits: form.querySelector('[name="order[estimated_mailed_units]"]'),
        electionType: form.querySelector('[name="order[election_value]"]') || form.querySelector('[name="order[election_type]"]')
      };

      const electronicBallots = document.getElementById('electronic-ballots');
      if (!fields.totalUnits || !fields.mailedUnits || !electronicBallots) return;

      // Check if Special Assessment is selected
      if (fields.electionType && fields.electionType.value === 'SPA') {
        // For Special Assessment, electronic ballots must be 0
        if (parseInt(electronicBallots.value, 10) !== 0) {
          addError(electronicBallots, 'Electronic ballots are not permitted for Special Assessments');
          return false;
        }
      } else {
        // For other election types, validate the sum doesn't exceed total
        const total = parseInt(fields.totalUnits.value, 10) || 0;
        const mailed = parseInt(fields.mailedUnits.value, 10) || 0;
        const electronic = parseInt(electronicBallots.value, 10) || 0;

        if (total > 0 && (mailed + electronic) > total) {
          addError(fields.mailedUnits, 'Total of paper and electronic ballots exceeds total units');
          addError(electronicBallots, 'Total of paper and electronic ballots exceeds total units');
          return false;
        }
      }

      removeError(electronicBallots);
      return true;
    }

    // Force scroll to the first error with a direct approach
    function forceScrollToFirstError() {
      console.log('Forcing scroll to first error');

      // Use a slight timeout to ensure DOM is updated
      setTimeout(function() {
        const firstError = document.querySelector('.input-error');
        if (firstError) {
          console.log('Found error element, scrolling to it');

          // Try multiple scrolling approaches for maximum compatibility
          try {
            // Method 1: Direct window scroll with slower behavior
            window.scrollTo({
              top: firstError.getBoundingClientRect().top + window.pageYOffset - 100,
              behavior: 'smooth'
            });

            // Method 2: Use a manual smooth scroll for more control over speed
            smoothScrollTo(firstError.getBoundingClientRect().top + window.pageYOffset - 100, 1000);

            // Focus on the field
            setTimeout(function() {
              firstError.focus();

              // Add temporary highlight
              firstError.classList.add('highlight-error');
              setTimeout(function() {
                firstError.classList.remove('highlight-error');
              }, 1500);
            }, 1000); // Focus after scroll completes

          } catch (err) {
            console.error('Error during scrolling:', err);

            // Fallback method
            window.scrollTo(0, firstError.offsetTop - 100);
          }
        } else {
          console.warn('No error field found to scroll to');
        }
      }, 50);
    }

    // Custom smooth scroll function with adjustable duration
    function smoothScrollTo(targetY, duration) {
      const startY = window.pageYOffset;
      const difference = targetY - startY;
      const startTime = performance.now();

      function step() {
        const currentTime = performance.now();
        const elapsed = currentTime - startTime;

        // Use ease-out effect for smoother, slower deceleration
        const progress = Math.min(elapsed / duration, 1);
        const easeOutProgress = 1 - Math.pow(1 - progress, 3); // Cubic ease out

        window.scrollTo(0, startY + difference * easeOutProgress);

        if (elapsed < duration) {
          requestAnimationFrame(step);
        }
      }

      requestAnimationFrame(step);
    }

    // Validate the entire form
    function validateForm(form, fields) {
      console.log('Running form validation');

      // Clear previous errors
      clearAllErrors(form);

      // Track validity
      let isValid = true;

      // Required field validation
      if (fields.name && !validateRequiredField(fields.name, 'Association name is required')) isValid = false;
      if (fields.electionType && !validateRequiredField(fields.electionType, 'Please select an election type')) isValid = false;

      // Special assessment validation
      if (fields.electionType && fields.electionType.value === 'SPA') {
        const total = parseInt(fields.totalUnits.value, 10) || 0;
        const mailed = parseInt(fields.mailedUnits.value, 10) || 0;

        if (mailed !== total) {
          addError(fields.mailedUnits, 'For Special Assessments, paper ballots must equal total units');
          isValid = false;
        }

        const electronicBallots = document.getElementById('electronic-ballots');
        if (electronicBallots && parseInt(electronicBallots.value, 10) !== 0) {
          addError(electronicBallots, 'Electronic ballots are not permitted for Special Assessments');
          isValid = false;
        }
      }

      // Units validation
      if (fields.totalUnits) {
        const total = parseInt(fields.totalUnits.value, 10);
        if (isNaN(total) || total < 1) {
          addError(fields.totalUnits, 'Total units must be 1 or more');
          isValid = false;
        }
      }

      // Paper ballots validation
      if (fields.mailedUnits) {
        const mailedRaw = fields.mailedUnits.value.trim();
        const mailed = parseInt(mailedRaw, 10);
        const total = parseInt(fields.totalUnits?.value || '0', 10);

        if (mailedRaw === '' || isNaN(mailed)) {
          addError(fields.mailedUnits, 'Paper ballots cannot be empty');
          isValid = false;
        } else if (mailed < 0) {
          addError(fields.mailedUnits, 'Paper ballots cannot be negative');
          isValid = false;
        } else if (!isNaN(total) && mailed > total) {
          addError(fields.mailedUnits, 'Paper ballots cannot exceed total units');
          isValid = false;
        }
      }

      // Validate the sum of paper and electronic ballots
      const electronicBallots = document.getElementById('electronic-ballots');
      if (fields.mailedUnits && electronicBallots && fields.totalUnits) {
        const mailedRaw = fields.mailedUnits.value.trim();
        const electronicRaw = electronicBallots.value.trim();
        const totalRaw = fields.totalUnits.value.trim();

        const mailed = parseInt(mailedRaw, 10) || 0;
        const electronic = parseInt(electronicRaw, 10) || 0;
        const total = parseInt(totalRaw, 10) || 0;

        if (!isNaN(total) && total > 0 && (mailed + electronic) > total) {
          addError(fields.mailedUnits, 'Total of paper and electronic ballots exceeds total units');
          addError(electronicBallots, 'Total of paper and electronic ballots exceeds total units');
          isValid = false;
        }
      }

      // Date validation
      if (fields.meetingDate && !validateMeetingDate(fields.meetingDate)) isValid = false;

      // Contact info validation
      if (fields.firstName && !validateRequiredField(fields.firstName, 'First name is required')) isValid = false;
      if (fields.lastName && !validateRequiredField(fields.lastName, 'Last name is required')) isValid = false;
      if (fields.email && !validateEmail(fields.email)) isValid = false;

      console.log('Validation result:', isValid);
      return isValid;
    }

    // Validate a required field
    function validateRequiredField(field, message) {
      if (!field.value.trim()) {
        addError(field, message);
        return false;
      }
      removeError(field);
      return true;
    }

    // Validate email field
    function validateEmail(field) {
      const emailValue = field.value.trim();
      if (!emailValue) {
        addError(field, 'Email is required');
        return false;
      }

      // Basic email format validation
      if (!/\S+@\S+\.\S+/.test(emailValue)) {
        addError(field, 'Please enter a valid email address');
        return false;
      }

      removeError(field);
      return true;
    }

    // Validate meeting date
    function validateMeetingDate(field) {
      const dateValue = field.value;
      const inputDate = new Date(dateValue);
      const today = new Date();
      const minDate = new Date();
      minDate.setDate(today.getDate() + 4);

      if (!dateValue || isNaN(inputDate.getTime())) {
        addError(field, 'Meeting date is required and must be valid');
        return false;
      }

      if (stripTime(inputDate) < stripTime(minDate)) {
        addError(field, 'Meeting date must be at least 4 days in the future');
        return false;
      }

      removeError(field);
      return true;
    }

    // Update ballot counts when total units change
    function updateBallotCounts(fields, electronicBallots) {
      if (!fields.totalUnits || !fields.mailedUnits || !electronicBallots) return;

      const total = parseInt(fields.totalUnits.value, 10);
      const mailedRaw = fields.mailedUnits.value.trim();
      const mailed = parseInt(mailedRaw, 10);
      const electronicRaw = electronicBallots.value.trim();
      const electronic = parseInt(electronicRaw, 10);

      // Check if Special Assessment is selected
      const isSpecialAssessment = fields.electionType && fields.electionType.value === 'SPA';

      if (!isNaN(total) && total > 0) {
        if (!isSpecialAssessment) {
          electronicBallots.removeAttribute('disabled');
        }

        // For Special Assessment, always set paper ballots to total and electronic to 0
        if (isSpecialAssessment) {
          fields.mailedUnits.value = total;
          electronicBallots.value = 0;
          highlightAnimateField(fields.mailedUnits);
          return;
        }

        // For other election types, follow normal logic
        if ((isNaN(mailed) || mailed === 0) && (isNaN(electronic) || electronic === 0)) {
          fields.mailedUnits.value = total;
          electronicBallots.value = 0;
          // Apply the enhanced animation
          highlightAnimateField(fields.mailedUnits);
        } else if (!isNaN(electronic) && electronic >= 0 && electronic <= total) {
          // Update paper ballots
          fields.mailedUnits.value = total - electronic;
          highlightAnimateField(fields.mailedUnits);
        } else if (!isNaN(mailed) && mailed >= 0 && mailed <= total) {
          // Update electronic ballots
          electronicBallots.value = total - mailed;
          highlightAnimateField(electronicBallots);
        }
      } else {
        fields.mailedUnits.value = '';
        electronicBallots.value = '';
        electronicBallots.setAttribute('disabled', true);
      }
    }

    // Update paper ballots based on electronic
    function updatePaperBallots(fields, electronicBallots) {
      if (!fields.totalUnits || !fields.mailedUnits || !electronicBallots) return;

      // Skip for Special Assessment
      if (fields.electionType && fields.electionType.value === 'SPA') return;

      const total = parseInt(fields.totalUnits.value, 10);
      const electronic = parseInt(electronicBallots.value, 10);

      if (!isNaN(total) && !isNaN(electronic)) {
        // Ensure electronic doesn't exceed total
        const adjustedElectronic = Math.min(electronic, total);
        if (adjustedElectronic !== electronic) {
          electronicBallots.value = adjustedElectronic;
          highlightAnimateField(electronicBallots);
        }

        const mailed = total - adjustedElectronic;
        if (mailed >= 0) {
          fields.mailedUnits.value = mailed;
          highlightAnimateField(fields.mailedUnits);
        }
      }
    }

    // Update electronic ballots based on paper
    function updateElectronicBallots(fields, electronicBallots) {
      if (!fields.totalUnits || !fields.mailedUnits || !electronicBallots) return;

      // Skip for Special Assessment
      if (fields.electionType && fields.electionType.value === 'SPA') return;

      const total = parseInt(fields.totalUnits.value, 10);
      const mailed = parseInt(fields.mailedUnits.value, 10);

      if (!isNaN(total) && !isNaN(mailed)) {
        // Ensure mailed doesn't exceed total
        const adjustedMailed = Math.min(mailed, total);
        if (adjustedMailed !== mailed) {
          fields.mailedUnits.value = adjustedMailed;
          highlightAnimateField(fields.mailedUnits);
        }

        const electronic = total - adjustedMailed;
        if (electronic >= 0) {
          electronicBallots.value = electronic;
          highlightAnimateField(electronicBallots);
        }
      }
    }

    // Enhanced animation function that combines both the pulse effect and the flash effect
    function highlightAnimateField(field) {
      // Clear any existing errors on the field first
      removeError(field);

      // Add both animation classes for a combined effect
      field.classList.add('highlight-error', 'animate-flash-autofill');

      // Remove the classes after animation completes
      setTimeout(function() {
        field.classList.remove('highlight-error', 'animate-flash-autofill');
      }, 1500); // Match the duration of the pulse-error animation
    }

    // Strip time portion from date for comparison
    function stripTime(date) {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    }

    // Add error message to a field
    function addError(field, message) {
      if (!field) return;

      try {
        // Create unique error ID based on field name
        const errorId = (field.name || 'unnamed-field').replace(/\W+/g, '-') + '-error';

        // Don't duplicate errors
        if (document.getElementById(errorId)) return;

        // Create error message element
        const errorElement = document.createElement('p');
        errorElement.id = errorId;
        errorElement.className = 'mt-1 text-sm text-red-600';
        errorElement.textContent = message;

        // Mark field as invalid
        field.setAttribute('aria-invalid', 'true');
        field.classList.add('border-red-600', 'input-error');

        // Add error message after the field
        if (field.parentNode) {
          field.parentNode.appendChild(errorElement);
        }
      } catch (err) {
        console.error('Error adding validation message:', err);
      }
    }

    // Remove error message from a field
    function removeError(field) {
      if (!field) return;

      try {
        const errorId = (field.name || 'unnamed-field').replace(/\W+/g, '-') + '-error';
        const errorElement = document.getElementById(errorId);

        if (errorElement && errorElement.parentNode) {
          errorElement.parentNode.removeChild(errorElement);
        }

        field.classList.remove('border-red-600', 'input-error');
        field.removeAttribute('aria-invalid');
      } catch (err) {
        console.error('Error removing validation message:', err);
      }
    }

    // Clear all error messages
    function clearAllErrors(form) {
      // Remove error messages
      form.querySelectorAll('.text-sm.text-red-600[id$="-error"]').forEach(function(element) {
        if (element.parentNode) {
          element.parentNode.removeChild(element);
        }
      });

      // Remove error styling from fields
      form.querySelectorAll('.input-error').forEach(function(field) {
        field.classList.remove('border-red-600', 'input-error');
        field.removeAttribute('aria-invalid');
      });
    }
  });

  // Add styles for animations
  document.addEventListener('turbolinks:load', function() {
    // Check if the style already exists to avoid duplicates
    if (!document.getElementById('form-animation-styles')) {
      const style = document.createElement('style');
      style.id = 'form-animation-styles';
      style.textContent = `
        .highlight-error {
          animation: pulse-error 1.5s;
        }

        @keyframes pulse-error {
          0% { box-shadow: 0 0 0 0 rgba(220, 38, 38, 0.7); }
          50% { box-shadow: 0 0 0 10px rgba(220, 38, 38, 0.5); }
          100% { box-shadow: 0 0 0 0 rgba(220, 38, 38, 0); }
        }

        .animate-flash-autofill {
          animation: flash-autofill 0.8s;
        }

        @keyframes flash-autofill {
          0% { background-color: transparent; }
          50% { background-color: rgba(167, 139, 250, 0.2); }
          100% { background-color: transparent; }
        }

        /* Combined animation style */
        .highlight-autofill {
          animation: pulse-autofill 1.5s;
        }

        @keyframes pulse-autofill {
          0% {
            box-shadow: 0 0 0 0 rgba(167, 139, 250, 0.7);
            background-color: transparent;
          }
          50% {
            box-shadow: 0 0 0 10px rgba(167, 139, 250, 0.5);
            background-color: rgba(167, 139, 250, 0.2);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(167, 139, 250, 0);
            background-color: transparent;
          }
        }
      `;
      document.head.appendChild(style);
    }
  });
